module.exports = __webpack_public_path__ + "img/gmail.83391582.png";